<template>
    <div>
        <div class="card my-3">
            <div class="card-header">反馈问卷管理</div>
            <div class="card-body" style="min-height: 600px">
                <div v-if="surveyPaperData.length===0" class="alert alert-warning">没有需要填写的反馈问卷</div>

                <table v-else class="table table-bordered">
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 5%">序号</th>
                        <th class="text-center align-middle" style="width: 25%">名称</th>
                        <th class="text-center align-middle" style="width: 25%">问卷模板</th>
                        <th class="text-center align-middle" style="width: 35%">讲师课程</th>
                        <th class="text-center align-middle" style="width: 10%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(paper, index) in surveyPaperData">
                        <td class="text-center align-middle">{{index+1}}</td>
                        <td class="text-left align-middle">{{paper.surveyPaperName}}</td>
                        <td class="text-left align-middle">{{paper.surveyTemplateName}}</td>
                        <td class="text-left align-middle">
                            <ul class="mb-0">
                                <li v-for="(teacherCourse, index) in paper.teacherCourseData">
                                    {{teacherCourse.personName}} - {{teacherCourse.courseName}}
                                </li>
                            </ul>
                        </td>
                        <td class="text-center align-middle">
                            <router-link :to="{name: 'StudentSurveyPaperEdit', params: {surveyPaperId: paper.surveyPaperId}}" class="btn btn-primary btn-sm">填写问卷</router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
export default {
    name: "StudentSurveyManage",
    data: function () {
        return {
            studentId: this.$store.state.userInfo.userId,

            surveyPaperData: [],
            surveyTemplateInfo: {},
        };
    },
    mounted() {
        this.getSurveyPaperDataByStudent();
    },
    methods: {
        getSurveyPaperDataByStudent() {
            studyApi.survey.paper.getSurveyPaperDataByStudent(this.studentId).then(res => {
                this.surveyPaperData = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>